import { render, staticRenderFns } from "./CallbackRequestSummary.vue?vue&type=template&id=1fa5f110&"
import script from "./CallbackRequestSummary.vue?vue&type=script&lang=js&"
export * from "./CallbackRequestSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports